import request, { ResponseData } from '@/utils/request'
import { GroupItem, GroupList, EmployeeList } from './data.d'

// 获取分组
export async function fetchDepartmentList(): Promise<ResponseData<GroupList>> {
  return request('/api/v1/training/dialogcase/group', {
    method: 'get',
  })
}

// 新增分组
export async function createDepartment(params): Promise<ResponseData<null>> {
  const param = {
    group: {
      name: params?.name,
      parent_id: params.parent_id,
    },
  }
  return request('/api/v1/training/dialogcase/group', {
    method: 'post',
    data: param,
  })
}

// 删除分组
export async function deleteDepartment(params): Promise<ResponseData<null>> {
  // console.log('删除分组的参数：',params);
  return request('/api/v1/training/dialogcase/group', {
    method: 'delete',
    data: params,
  })
}

// 批量删除分组
export async function deleteGroups(params): Promise<ResponseData<null>> {
  return request('/api/v1/training/dialogcase/group/batch/delete', {
    method: 'delete',
    data: params,
  })
}

// 修改分组
export async function updateDepartment(params): Promise<ResponseData<null>> {
  return request('/api/v1/training/dialogcase/group', {
    method: 'patch',
    data: params,
  })
}

// 移动分组
export async function dropDepartment(params): Promise<ResponseData<null>> {
  return request('/api/v1/training/dialogcase/group', {
    method: 'put',
    data: params,
  })
}

interface Params {
  group_id: string
  page: {
    is_descending: boolean
    order_by: string
    page_num: number
    page_size: number
    search_key: string
  }
}

export async function fetchCaseList(params: Params): Promise<ResponseData<EmployeeList>> {
  return request('/api/v1/training/dialogcase/list', {
    method: 'post',
    data: params,
  })
}

//  查找tenant下所有会话案例 （会话案例）
// export async function dialogcaseList(params) {
//   return request('/api/v1/training/dialogcase/list', {
//     method: 'post',
//     data: params,
//   })
// }

// 右边的编辑
export async function updateCase(params): Promise<ResponseData<EmployeeList>> {
  return request('/api/v1/training/dialogcase', {
    method: 'patch',
    data: params,
  })
}

// 右边的删除
export async function deleteCase(params): Promise<ResponseData<null>> {
  params.ids = params.dialog_ids
  return request('/api/v1/training/dialogcase/batch/delete', {
    method: 'post',
    data: params,
  })
}

// 移动案例到其他分组
export async function moveCase(params): Promise<ResponseData<null>> {
  return request('/api/v1/training/dialogcase/move', {
    method: 'post',
    data: params,
  })
}

// 批量导入
export async function importFile(params: string[]): Promise<ResponseData<null>> {
  return request('/api/v1/training/dialogcase/batch/delete', {
    method: 'post',
    data: params,
  })
}

//导入上传按钮
export async function importDialogFile(params: string[]): Promise<ResponseData<null>> {
  return request('/api/v1/sys/dialog_case/upload', {
    method: 'post',
    data: params,
  })
}

export async function dialogDetail(params: string[]): Promise<ResponseData<null>> {
  // console.log('params',params);
  return request('/api/v1/training/dialogcase/detail', {
    method: 'post',
    data: params,
  })
}

export function usersList(params) {
  return request('/api/v1/users/list', {
    method: 'post',
    data: params,
  })
}
